<template>
      <div>
           <barra-navegacao :visiblebar="true" :visiblebutton="true"/>
            <b-card
            v-for="(corredor,index) in corredores" :key="index"
                @click="listarSalas(corredor.corredor ? corredor.corredor.idCorredor : corredor.idCorredor)"               
                class="modern-nav-card">
              <div>
                <strong>{{corredor.descricao || (corredor.corredor ? corredor.corredor.descricao : '')}}</strong>
              </div>
            </b-card>
      </div>
</template>

<script>
import BarraNavegacao from '../components/BarraNavegacao.vue';

export default {
  components: { BarraNavegacao },
  data(){
    return{
      corredores: []
    }
  },

  created(){
    this.listarCorredores(this.$route.params.idBloco, this.$route.params.idAndar);
  },

  methods:{
    listarCorredores(idBloco, idAndar) {
      this.$http
        .get(`/andar-corredores/bloco/${idBloco}/andar/${idAndar}`)
        .then((res) => {
          this.corredores = res.data;
      });
    },
    listarSalas(idCorredor) {
      this.$router.push("/sala/"+this.$route.params.idBloco+"/"+this.$route.params.idAndar+"/"+idCorredor)
    },
  }
};
</script>

<style >

</style>
